import { api } from './NetworkUtility';
import { logError } from './ErrorService';

export const getUsers = async (companyNumber, callbackHandler, callbackErrorHandler) => {

    const url = `/companies/${companyNumber}/users`;
    return api.get(url)
        .then(response => {
            if (response?.data?.users && response?.data?.users.length) {
                return response.data.users;
            } else {
                return Promise.reject("No user data");
            }
        })
        .then(data => {
            callbackHandler(data);
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?u";
                });
            } else {
                callbackErrorHandler(error);
            }
        });
}

export const getAllUsers = async (callbackHandler, callbackErrorHandler) => {

    const url = `/admin/getAllUsers`;
    return api.get(url)
        .then(response => {
            if (response?.data?.users && response?.data?.users.length) {
                return response.data.users;
            } else {
                return Promise.reject("No user data");
            }
        })
        .then(data => {
            callbackHandler(data);
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?u";
                });
            } else {
                callbackErrorHandler(error);
            }
        });
}

export const getUser = (uuid, companyNumber, callbackHandler) => {

    const url = `/companies/${companyNumber}/user/${uuid}`;

    api.get(url)
        .then(response => {
            return response.data;
        })
        .then(data => {
            callbackHandler(data)
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?su";
                });
            } else {
                callbackHandler(null);
            }
        });
}

export const getUserUUID = (callbackHandler) => {
    const url = `/admin/getUserUUID`;
    api.get(url)
        .then(response => {
            return response;
        })
        .then(data => {
            callbackHandler(data)
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?su";
                });
            } else {
                callbackHandler(null);
            }
        });
}

export const getSystemAdminUser = (uuid, callbackHandler) => {

    const url = `/admin/getSystemAdminUser/${uuid}`;
    api.get(url)
        .then(response => {
            return response.data;
        })
        .then(data => {
            callbackHandler(data)
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?su";
                });
            } else {
                callbackHandler(null);
            }
        });
}

export const getUserFirstName = (companyNumber, callbackHandler) => {

    const url = `/companies/${companyNumber}/getUserFirstName`;

    api.get(url)
        .then(response => {
            return response.data;
        })
        .then(data => {
            callbackHandler(data)
        })
        .catch(function (error) {
            callbackHandler(null);
        });
}

export const saveUser = async (user, companyNumber) => {
    const request = {
        "uuid": user.uuid,
        "username": user.username,
        "cc_org_id": user.customerId,
        "name": user.name,
        "email": user.email,
        "is_active": user.isActive,
        "role_uuid": user.companyRole.roleUuid
    }

    const url = `/companies/${companyNumber}/users`;

    // errors will be handled by component 
    return api.post(url, request).then(response => response.data);
}

export const saveInternalUser = async (user) => {
    const request = {
        "uuid": user.uuid,
        "username": user.username,
        "cc_org_id": user.customerId,
        "is_active": user.isActive,
        "internal_role_uuid": user.internalRole?.roleUuid,
        "is_super": user.isSuper,
        "name": user.name
    }

    const url = `/admin/saveInternalUser`;

    // errors will be handled by component 
    return api.post(url, request).then(response => response.data);
}

export const getInternalRoles = (callbackHandler) => {
    const url = '/admin/getInternalRoles';

    api.get(url)
        .then(response => {
            if (response?.data?.internalRoles && response?.data?.internalRoles.length) {
                return response.data.internalRoles;
            } else {
                return Promise.reject("No internal role data");
            }
        })
        .then(data => {
            callbackHandler(data);
        })
        .catch(function (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?cr";
                });
            } else {
                //global error
                window.location = "/error?cr";
            }
        })
}

export const activateUser = (uuid, reason, isActive, callbackHandler) => {
    const request = {
        "isActive": isActive,
        "reason": reason
    }

    const url = '/admin/activate/' + uuid;

    api.post(url , request)
        .then(response => {
            callbackHandler(response.data);
        })
        .catch(function (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?cr";
                });
            } else {
                //global error
                window.location = "/error?cr";
            }
        })
}

export const activateCompanyUser = (companyNumber, uuid, reason, isActive, callbackHandler, errorHandler) => {
    const url = `/companies/${companyNumber}/users/activate/${uuid}`;
    
    const request = {
        "isActive": isActive,
        "reason": reason
    }

    api.post(url , request)
        .then(response => {
            callbackHandler(response.data);
        })
        .catch(function (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?cr";
                });
            } else {
                errorHandler(error.response.data);
            }
        })
}

export const saveInternalRole = async (role, callbackHandler, callbackHandlerError) => {
    const request = {
        "internalRoleUuid": role.roleUuid,
        "roleName": role.roleName,
        "description": role.description,
        "permissions": role.permissions
    }

    const url = `/admin/saveInternalRole`;

    // errors will be handled by component 
    return api.post(url, request)
        .then(response => {
            callbackHandler(response);
        })
        .catch(error => {
            callbackHandlerError(error.response);
        });
}